/**
 * For supported package types,
 * https://auctane.atlassian.net/browse/WEBAPPS-30894
 */
export default Object.freeze({
	// USPS supported package types
	Postcard: 'Postcard', // ?? not seen on the spec yet ??
	Envelope: 'Envelope', // ?? not seen on the spec yet ??
	Letter: 'Letter', // ?? not seen on the spec yet ??
	LargeEnvelope: 'large_envelope', // 'LargeEnvelopeorFlat'
	Package: 'package', // 'Package'
	UspsSmallFlatRateBox: 'usps_small_flat_rate_box', // 'SmallFlatRateBox'
	UspsMediumFlatRateBox: 'usps_medium_flat_rate_box', // 'FlatRateBox'
	UspsLargeFlatRateBox: 'usps_large_flat_rate_box', // 'LargeFlatRateBox
	UspsFlatRateEnvelope: 'usps_flat_rate_envelope', // 'FlatRateEnvelope'
	UspsPaddedFlatRateEnvelope: 'usps_padded_flat_rate_envelope', // 'FlatRatePaddedEnvelope'
	UspsLegalFlatRateEnvelope: 'usps_legal_flat_rate_envelope', // 'LegalFlatRateEnvelope'

	PrintAtHomeLabel: 'print_at_home_Label',
	DropOffNoLabelNeeded: 'drop_off_no_label_needed',

	// UPS supported package types
	UpsLetter: 'ups_letter', // 'Letter'
	UpsPak: 'ups_pak', // 'Pak'
	UpsTube: 'ups_tube', // 'Tube'
	UpsExpressBoxSmall: 'ups_express_box_small', // 'ExpressBoxSmall'
	UpsExpressBoxMedium: 'ups_express_box_medium', // 'ExpressBoxMedium'
	UpsExpressBoxLarge: 'ups_express_box_large', // 'ExpressBoxLarge'

	// FedEx supported package types
	FedExEnvelope: 'fedex_envelope', // 'Envelope'
	FedExPak: 'fedex_pak', // 'Pak'
	FedExTube: 'fedex_tube', // 'Tube'
	FedExOneRateEnvelope: 'fedex_one_rate_envelope', // 'OneRateEnvelope'
	FedExOneRatePak: 'fedex_one_rate_pak', // 'OneRatePak'
	FedExOneRateTube: 'fedex_one_rate_tube', // 'OneRateTube'
	FedExOneRateSmallBox: 'fedex_one_rate_small_box', // 'OneRateSmallBox'
	FedExOneRateMediumBox: 'fedex_one_rate_medium_box', // 'OneRateMediumBox'
	FedExOneRateLargeBox: 'fedex_one_rate_large_box', // 'OneRateLargeBox'
	FedExOneRateExtraLargeBox: 'fedex_one_rate_extra_large_box', // 'OneRateExtraLargeBox'
	FedEx10kgBox: 'fedex_10kg_box', // '10KGBox'
	FedEx25kgBox: 'fedex_25kg_box', // '25KGBox'

	// DHL supported package types
	ExpressEnvelope: 'express_envelope', // 'ExpressEnvelope'

	// CanadaPost supported package types
	CanadaPostEnvelope: 'canada_post_envelope', // 'Envelope'
	CanadaPostPak: 'canada_post_pak', // 'Pak'
});
